<template>
<w-settings-summary ref="settingsSummary" :menu="menu" @change="onChangeMenu">
  <component slot="activeView" :is="activeView" :title="activeMenu.name"></component>
</w-settings-summary>
</template>

<script>
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import summaryApi from '@/api/settings/settings-summary';
import { getValueAfterCheckEmpty } from '@/utils/string';
import WSettingsSummary from '@/components/template/SettingsSummary';
import WProcessSettings from './ProcessSettings';
import WPortSettings from './PortSettings';
import WFileDetectSettings from './FileDetectSettings';
// import WCommandSettings from './CommandSettings';
// import WWFileDetectSettings from './FileDetectSettings';
import WSecuritySettings from './SecuritySettings';
import WAmsSettings from './AmsSettings';

export default {
  name: 'WServerSettings',
  components: {
    WSettingsSummary,
    WProcessSettings,
    WPortSettings,
    WFileDetectSettings,
    // WCommandSettings,
    // WWFileDetectSettings,
    WSecuritySettings,
    WAmsSettings,
  },
  data() {
    return {
      activeMenu: {},
      activeView: null,
      menu: [
        {
          id: 'processSettings',
          name: '프로세스 설정',
          desc: ['중요 프로세스에 관련된 설정이 가능합니다.', '중요 프로세스 등록, 템플릿 생성 및 과부하 예외 설정이 가능합니다.'],
          data: null,
          orderbyIndex: 1,
        },
        // {
        //   id: 'commandSettings',
        //   name: '스크립트 설정',
        //   desc: ['서버에서 수행할 수 있는 스크립트를 설정합니다.', '해당 스크립트는 ADMIN, 관리자 등급에서 수행할 수 있습니다.'],
        //   data: null,
        //   orderbyIndex: 2,
        // },
        {
          id: 'portSettings',
          name: '포트 설정',
          desc: ['서버 운영 포트에 대한 설정이 가능합니다.', '서비스 포트 설정, 포트 인증/비인증 설정 등이 가능합니다.'],
          data: null,
          orderbyIndex: 3,
        },
        {
          id: 'fileDetectSettings',
          name: '파일 감시 설정',
          desc: ['대용량 파일 생성 및 파일 변경/미변경 여부를 설정합니다.'],
          data: null,
          orderbyIndex: 4,
        },
        {
          id: 'securitySettings',
          name: '보안 설정',
          desc: ['서버 운영 포트에 대한 접근 차단 여부를 설정합니다.', '접근 차단 포트 등록 및 접근 가능 IP/MAC 주소를 등록할 수 있습니다.'],
          data: null,
          orderbyIndex: 5,
        },
        {
          id: 'amsSettings',
          name: '자동화 설정',
          desc: ['자동화 수행에 대한 설정이 가능합니다.', '자동화 변수, 태스크, 작업, 템플릿을 설정합니다.'],
          data: null,
          orderbyIndex: 6,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onChangeMenu(activeView, activeMenu) {
      this.activeView = activeView;
      this.activeMenu = activeMenu;
    },
    clearActiveView() {
      this.$refs.settingsSummary.clearActiveView();
      this.loadData();
    },
    loadData() {
      summaryApi.getServerSettingSummaryCount().then((response) => {
        const result = response.data;
        if (result.success === true && !isEmpty(result.data)) {
          const data = result.data;
          const processSettingsData = [`현재 등록된 중요 프로세스의 수는 <em>${getValueAfterCheckEmpty(data.majorPrcessCount)}개</em> 입니다.`];
          const portSettingsData = [`현재 등록된 중요 TCP/UDP 포트 수는 <em>${getValueAfterCheckEmpty(data.majorPortCount)}개</em>입니다.`];
          const fileDetectSettingsData = [`현재 등록된 감지 폴더/파일 수는 <em>${getValueAfterCheckEmpty(data.detectFileCount)}개</em>입니다.`];
          const securitySettingsData = [`현재 등록된 접근 차단 포트의 수는 <em>${getValueAfterCheckEmpty(data.portCtrlCount)}개</em>입니다.`];
          // const commandSettingsData = [`현재 등록된 명령어 목록 수는 <em>${getValueAfterCheckEmpty(data.scriptCount)}개</em>입니다.`];
          const amsSettingsData = [`현재 등록된 템플릿 수는 <em>${getValueAfterCheckEmpty(data.triggerCount)}개</em>입니다.`];

          const processSettingsIndex = findIndex(this.menu, (item) => item.id === 'processSettings');
          this.menu[processSettingsIndex].data = processSettingsData;

          const portSettingsIndex = findIndex(this.menu, (item) => item.id === 'portSettings');
          this.menu[portSettingsIndex].data = portSettingsData;

          const fileDetectSettingsIndex = findIndex(this.menu, (item) => item.id === 'fileDetectSettings');
          this.menu[fileDetectSettingsIndex].data = fileDetectSettingsData;

          const securitySettingsIndex = findIndex(this.menu, (item) => item.id === 'securitySettings');
          this.menu[securitySettingsIndex].data = securitySettingsData;

          // const commandSettingsIndex = findIndex(this.menu, (item) => item.id === 'commandSettings');
          // this.menu[commandSettingsIndex].data = commandSettingsData;

          const amsSettingsIndex = findIndex(this.menu, (item) => item.id === 'amsSettings');
          this.menu[amsSettingsIndex].data = amsSettingsData;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/index.vue